import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { LocalizedTransportationOption } from '../../API/GoMoto';
import { useLocalization } from '../../context/Localization/localization';
import { GMCapitalize } from '../Case';
import css from './TransportationButtonList.module.scss';
import SizedIcon from '../Icon/SizedIcon/SizedIcon';
import { GMGenericButton } from '../ButtonBase';

interface ITransportButtonProps<T extends LocalizedTransportationOption = LocalizedTransportationOption> {
    transportOp: T;
    onClick: (transportOpt: T) => void;
    selected?: boolean;
}

export const TransportationButton = React.memo((props: ITransportButtonProps) => {
    const Localization = useLocalization();
    const parentRef = useRef<HTMLHeadingElement>(null);
    const originalFontSize = 'calc(12px + 2vmin)';

    useEffect(() => {
        const handleResize = () => {
            if (parentRef?.current) {
                const parentWidth: number = parseFloat(window.getComputedStyle(parentRef.current).width);
                const textElement: HTMLParagraphElement = parentRef.current.getElementsByTagName('p')[0];

                textElement.style.fontSize = originalFontSize;
                while (parseFloat(window.getComputedStyle(textElement).width) > parentWidth) {
                    textElement.style.fontSize = `${parseFloat(window.getComputedStyle(textElement).fontSize) - 0.5}px`;
                }
            }
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        window.dispatchEvent(new Event('resize'));
    }, []);

    return (
        <GMGenericButton
            title={Localization.formatString(Localization.ClickToSelectAsTransportation, props.transportOp.name) as string}
            onClick={() => props.onClick(props.transportOp)}
            id={Localization.formatString(Localization.ClickToSelectAsTransportation, props.transportOp.name) as string}
            ariaLabel={Localization.formatString(Localization.ClickToSelectAsTransportation, props.transportOp.name) as string}
            ariaChecked={props.selected}
        >
            <div className={classNames(css.transportationButton, props.selected ? css.selected : '')}>
                <div className={css.transportationIcon}>
                    <SizedIcon
                        iconType={props.transportOp.icon}
                        iconSize={'extraLarge'}
                        ariaLabel={Localization.formatString(Localization.TransportationIcon, props.transportOp.name) as string}
                    />
                </div>
                <h2 ref={parentRef}>
                    <GMCapitalize>{props.transportOp.name}</GMCapitalize>
                </h2>
            </div>
        </GMGenericButton>
    );
});
